import React from 'react';
import { Link } from 'react-router-dom';

import '../../interfaceSettings.css';

const Footer = () => {

    return (
        <div className="card footer-card">
            <div className="card-body text-center">
                <div className="footer-links d-flex justify-content-center">
                    <Link className="nav-link" to="/about">About</Link>
                    <Link className="nav-link" to="/privacy">Privacy</Link>
                </div>
                <p className="card-text mb-2">
                Copyright &copy; {new Date().getFullYear()} Walking Trails
                </p>
            </div>
        </div>
    );
};

export default Footer;